<template>
    <div class="components-field-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-module">
            <div class="module-item">
                <div class="module-top">
                    <div class="module-title">{{ props.data.szaqInfo?.title }}</div>
                    <!-- <div class="module-btn" @click="szaqDownLoad()">下载领域说明</div> -->
                </div>
                <a-collapse v-model:activeKey="szaqKey" accordion>
                    <a-collapse-panel v-for="item in props.data.szaqInfo?.list" :key="item.title" :header="item.title">
                        <div class="item-desc" v-html="item.desc"></div>
                    </a-collapse-panel>
                </a-collapse>
            </div>
            <div class="module-item">
                <div class="module-top">
                    <div class="module-title">{{ props.data.rgznInfo?.title }}</div>
                    <!-- <div class="module-btn" @click="rgznDownLoad()">下载领域说明</div> -->
                </div>
                <a-collapse v-model:activeKey="rgznKey" accordion>
                    <a-collapse-panel v-for="item in props.data.rgznInfo?.list" :key="item.title" :header="item.title">
                        <div class="item-desc" v-html="item.desc"></div>
                    </a-collapse-panel>
                </a-collapse>
            </div>
            <div class="box-btn">
                <div class="btn-box" @click="downLoad()">
                    <DownloadOutlined :style="{marginRight: '12px', fontSize: '24px'}"/>
                    完整领域说明
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { DownloadOutlined } from '@ant-design/icons-vue';
import { ref } from 'vue';

const szaqKey = ref([]);
const rgznKey = ref([]);

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const downLoad = () => {
    window.open(props.data.szaqInfo.downLoadUrl)
}
</script>

<style lang="scss" scoped>
.components-field-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 96px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 30px;
            height: 30px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 28px;
            font-weight: 700;
            line-height: 39px;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-module{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 40px;
        border-radius: 12px;
        background: rgb(255, 255, 255);
        padding: 36px 49px;
        .module-item{
            width: 100%;
            margin-bottom: 42px;
            .module-top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 24px;
                .module-title{
                    color: rgb(30, 89, 191);
                    font-family: 阿里巴巴普惠体 2.0;
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                }
                .module-btn{
                    cursor: pointer;
                    color: rgb(30, 89, 191);
                    text-decoration: underline rgb(30, 89, 191);
                }
            }
            .item-desc{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2;
                font-size: 14px;
                font-weight: 300;
                line-height: 26px;
                letter-spacing: 0px;
                text-align: justify;
            }
            :deep(.ant-collapse){
                // border: 1px solid #e2e2ed;
                border: none;
                border-top: 1px solid #e2e2ed;
                border-bottom: 1px solid #e2e2ed;
                background-color: #ffffff;
                font-size: 16px;
            }
            :deep(.ant-collapse > .ant-collapse-item) {
                border-bottom: 1px solid #e1e3ee;
                &:last-child {
                    border-bottom: none;
                }
            }
        }
        .box-btn{
            width: 100%;
            display: flex;
            justify-content: center;
            // margin-top: 56px;
            .btn-box{
                cursor: pointer;
                padding: 0 20px;
                height: 50px;
                border-radius: 8px;
                // background: linear-gradient(180.00deg, rgb(88, 142, 235),rgb(30, 89, 191) 100%);
                background-image: linear-gradient(45deg, rgb(30, 89, 191) 0%, rgb(88, 142, 235)  51%, rgb(30, 89, 191)  100%);
                display: flex;
                align-items: center;
                color: rgb(255, 255, 255);
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 16px;
                font-weight: 500;
                justify-content: center;
                text-transform: uppercase;
                transition: 0.5s;
                background-size: 200% auto;
                border: 0px;
                box-shadow: 0px 0px 14px -7px rgb(88, 142, 235);
                img{
                    height: 30px;
                    margin-right: 12px;
                }
                &:hover {
                    background-position: right center;
                    /* change the direction of the change here */
                    color: #fff;
                    text-decoration: none;
                }
        
                &:active {
                    transform: scale(0.95);
                }
            }
    
        }
    }
}
</style>
